/* eslint-disable @typescript-eslint/no-explicit-any */
import { Environments } from '../types/environments';

export interface UrlConfig {
	env: Environments;
	ctkUrl: string;
}

export function getEnvironmentUrls() {
	return (window as any).APP_ENV as UrlConfig;
}

export function setDefaultUrls() {
	console.info(`getEnvironmentUrls: ${getEnvironmentUrls()}`);
	if (!(window as any).APP_ENV) {
		console.info('APP_ENV not found: setting default urls');
		(window as any).APP_ENV = {
			env: 'dev',
			ctkUrl: 'https://api-ctk.imaginelearning.com/api',
		};
	}
}

export function getOtkV2AtStylesUrl() {
	const { env } = getEnvironmentUrls();
	switch (env) {
		case Environments.Development:
			return 'https://assets-ctk-dev.imaginelearning.com/content/reader-dev/at-styles-latest-nocache.css';
		case Environments.QA:
			return 'https://assets-ctk-qa.imaginelearning.com/content/reader-qa/at-styles-latest-nocache.css';
		case Environments.Staging:
			return 'https://assets-ctk-staging.imaginelearning.com/content/reader-staging/at-styles-latest-nocache.css';
		case Environments.Production:
			return 'https://assets-ctk.imaginelearning.com/content/reader-prod/at-styles-latest-nocache.css';
		default:
			return 'https://assets-ctk-dev.imaginelearning.com/content/reader-dev/at-styles-latest-nocache.css';
	}
}

export function getOtkV2ReaderUrl(readerVersion?: string | null) {
	const { env } = getEnvironmentUrls();
	const readerPath = readerVersion ? `${readerVersion}/reader` : 'reader-nocache';
	switch (env) {
		case Environments.QA:
			return `https://assets-ctk-qa.imaginelearning.com/content/reader-qa/${readerPath}`;
		case Environments.Staging:
			return `https://assets-ctk-staging.imaginelearning.com/content/reader-staging/${readerPath}`;
		case Environments.Production:
			return `https://assets-ctk.imaginelearning.com/content/reader-prod/${readerPath}`;
		default:
			return `https://assets-ctk-dev.imaginelearning.com/content/reader-dev/${readerPath}`;
	}
}
